import { EXTENSIONS } from 'probonio-shared-ui/registry';
import { ExtensionBuilder } from 'probonio-shared-ui/registry/extension-definition';
import { BenefitListItemExtensionInterface } from '../../../extension/interface/benefit-list-item.extension.interface';
import { BenefitMetadataExtensionInterface } from '../../../extension/interface/benefit-metadata.extension.interface';
import { InternetBenefitListItemExtension } from './internet-benefit-list-item.extension';
import { InternetBenefitMetadataExtension } from './internet-benefit-metadata.extension';

EXTENSIONS.registerExtension(
  new ExtensionBuilder('internet')
    .add(BenefitMetadataExtensionInterface, new InternetBenefitMetadataExtension())
    .add(BenefitListItemExtensionInterface, new InternetBenefitListItemExtension())
    .build(),
);
